/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_No_Profile_ResultsInputs */

const en_task_settings_no_profile_results = /** @type {(inputs: Task_Settings_No_Profile_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching profiles.`)
};

const pt_br2_task_settings_no_profile_results = /** @type {(inputs: Task_Settings_No_Profile_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum perfil encontrado.`)
};

/**
* | output |
* | --- |
* | "No matching profiles." |
*
* @param {Task_Settings_No_Profile_ResultsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_no_profile_results = /** @type {((inputs?: Task_Settings_No_Profile_ResultsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_No_Profile_ResultsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_no_profile_results(inputs)
	return pt_br2_task_settings_no_profile_results(inputs)
});